import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiGithub,
  SiDocker,
  SiNginx,
  SiHeroku,
  SiNetlify,
  SiAwsamplify
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
     
     <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <SiGithub />
      </Col>
      {/* <Col xs={4} md={2} className="tech-icons">
        <SiAwsamplify />
      </Col> */}
      {/* <Col xs={4} md={2} className="tech-icons">
      <SiDocker />
      </Col> */}
      {/* <Col xs={4} md={2} className="tech-icons">
      <SiNginx />
      </Col> */}
      <Col xs={4} md={2} className="tech-icons">
        <SiNetlify />
      </Col>
      
      <Col xs={4} md={2} className="tech-icons">
        <SiHeroku/>
      </Col>

    </Row>
  );
}

export default Toolstack;
